import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { subscribeRouteChangeStart } from './subscribeRouteChange';
import type { RouteChangeStartHandler } from './types';

/**
 * Runs `handler` when a client-side navigation starts. React Router 7
 * implementation will use location subscription or `useBlocker`.
 */
export const useRouteChangeStart = (
  handler: RouteChangeStartHandler,
  enabled = true,
): void => {
  const { events } = useRouter();
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const wrapped: RouteChangeStartHandler = (url) => {
      handlerRef.current(url);
    };

    return subscribeRouteChangeStart(events, wrapped);
  }, [events, enabled]);
};
